export default function OnlineStatus({ online, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium ${online ? "text-brand-fresh" : "text-brand-muted"} ${className}`.trim()}
      data-testid="expert-online-status"
    >
      <span className={`h-2 w-2 rounded-full ${online ? "bg-[#39A56E]" : "bg-[#AAA39A]"}`}/>
      {online ? "Online" : "Ikke online"}
    </span>
  );
}

